import { Multiselect } from '@ardoq/select';
import { FilterValue } from '@ardoq/api-types';
import { RemoveFilterButtonInTopRightCorner, SelectContainer } from './atoms';
import { CheckboxColumnFilterProps } from '../types';
import { Maybe } from '@ardoq/common-helpers';

const CheckboxColumnFilter = ({
  column,
  selected,
  options,
  onValueChange,
  menuTarget,
  removeFilter,
  isReadOnly,
}: CheckboxColumnFilterProps & {
  menuTarget: Maybe<HTMLElement>;
}) => {
  return (
    <SelectContainer>
      {!isReadOnly && (
        <RemoveFilterButtonInTopRightCorner
          onClick={() => removeFilter(column.key)}
        />
      )}
      <Multiselect<FilterValue>
        label={column.label}
        placeholder={`Select...`}
        options={options}
        value={selected}
        onValueChange={onValueChange}
        dataTestId={'report-sidebar-multiselect'}
        menuPortalTarget={menuTarget}
        isReadOnly={isReadOnly}
        isClearable={!isReadOnly}
      />
    </SelectContainer>
  );
};

export { CheckboxColumnFilter };
